import {Directive, ElementRef, inject, OnInit} from '@angular/core';
import {TableComponent} from '@app/modules/table/table.component';
import {FormFilterTableControlService} from '@app/modules/table/services/form-filter-table-control.service';
import {takeUntil} from 'rxjs';
import {TuiDestroyService} from '@taiga-ui/cdk';

@Directive({
    selector: '[tableAutoHeight]'
})
export class TableAutoHeightDirective implements OnInit {
    readonly formFilter: FormFilterTableControlService = inject(FormFilterTableControlService);
    readonly #destroy$: TuiDestroyService = inject(TuiDestroyService);

    constructor(
        private el: ElementRef,
        private table: TableComponent) {
    }

    ngOnInit(): void {
        this.formFilter.isOpenFilter$
            .pipe(takeUntil(this.#destroy$))
            .subscribe((val) => {
            this.table.isFullHeight = !val;
        });
    }
}
